<template>
  <q-page>
    <div v-if="$apollo.loading">Loading...</div>
    <q-table v-else title="Accounts"
             :columns="columns"
             :data="sortedColours"
             :pagination.sync="pagination" flat
             :filter="filter" >

      <template v-slot:body-cell-favourites="props">
        <q-td :props="props">
          <q-checkbox :value="props.value" @input="v => setFavourite(props.row.name, v)"></q-checkbox>
        </q-td>
      </template>

      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template v-slot:body-cell-hex="props">
        <q-td :props="props">
          <div :style="{border: '1px silver solid', backgroundColor: props.value, width: '25px',height: '25px'}">
            <q-tooltip>{{props.value}}</q-tooltip>
          </div>
        </q-td>
      </template>

    </q-table>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'
import { mapState } from 'vuex'

export default {
  name: 'PageACcountFavouriteColours',
  apollo: {
    productColours: {
      query: gql`
      query fetchProductColours {
        productColours
      }
    `,
      deep: true,
      fetchPolicy: 'network-only',
      update (result) {
        return result.productColours.map(colour => JSON.parse(colour))
      }
    }
  },
  computed: {
    ...mapState('auth', ['currentAccount']),
    sortedColours () {
      const data = [...this.productColours]
      data.sort((a, b) => {
        const supergroupA = a?.superGroup === 'Custom' ? 'zzzcustom' : a?.superGroup
        const supergroupB = b?.superGroup === 'Custom' ? 'zzzcustom' : b?.superGroup
        const compareSuperGroup = supergroupA?.localeCompare(supergroupB)
        // const compareFavourites = b?.favourites - a?.favourites
        const compareGroup = a?.group?.localeCompare(b?.group)

        return compareSuperGroup || compareGroup
      })
      return data
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return 'Unknown'
      return moment(t).fromNow()
    },
    deleteAccount (account) {
      this.$q.dialog({
        title: 'Delete Account',
        message: `Are you sure you want to delete ${account.companyName}?`,
        cancel: true
      }).onOk(() => {
        // this.deleteCartItem(item)
        console.log('implement delete!')
      })
    },
    customSort (rows, sortBy, descending) {
      const data = [ ...rows ]
      data.sort((a, b) => {
        const supergroupA = a?.superGroup === 'Custom' ? 'zzzcustom' : a?.superGroup
        const supergroupB = b?.superGroup === 'Custom' ? 'zzzcustom' : b?.superGroup
        const compareSuperGroup = supergroupA.localeCompare(supergroupB)
        const compareFavourites = a?.favourites - b?.favourites
        const compareGroup = a?.group?.localeCompare(b?.group)

        return compareFavourites || compareSuperGroup || compareGroup
      })
      return data
    },
    async setFavourite (colourName, value) {
      let favourites = [...this.currentAccount.colourFavourites]
      if (!value && favourites.includes(colourName)) {
        const index = favourites.findIndex(el => el === colourName)
        if (index === -1) return
        favourites.splice(index, 1)
        await this.$store.dispatch('auth/updateCurrentAccount', { colourFavourites: favourites })
      }
      if (value && !favourites.includes(colourName)) {
        favourites.push(colourName)
        await this.$store.dispatch('auth/updateCurrentAccount', { colourFavourites: favourites })
      }
    }
  },
  data () {
    return {
      filter: '',
      columns: [
        { name: 'favourites', align: 'center', required: true, label: 'Favourites', field: row => this.currentAccount?.colourFavourites?.includes(row.name), sortable: false },
        { name: 'hex', align: 'left', required: true, label: 'Hex', field: 'hex', sortable: false },
        { name: 'superGroup', align: 'left', required: true, label: 'Super Group', field: 'superGroup', sortable: false },
        { name: 'group', align: 'left', required: true, label: 'Group', field: 'group', sortable: false },
        { name: 'name', align: 'left', required: true, label: 'Name', field: 'name', sortable: false },
        { name: 'ralName', align: 'left', required: true, label: 'RAL', field: 'ralName', sortable: false },
        { name: 'pantoneName', align: 'left', required: true, label: 'Pantone', field: 'pantoneName', sortable: false },
        // { name: 'aragonName', align: 'left', required: true, label: 'Aragon Name', field: 'aragonName', sortable: false },
        // { name: 'compxName', align: 'left', required: true, label: 'Composite X Name', field: 'compxName', sortable: false }
      ],
      pagination: {
        rowsPerPage: 20
      }
    }
  }
}
</script>
